export default function CoordGeoConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('coord.geo');
}

CoordGeoConfiguration.$inject = ['$translatePartialLoaderProvider'];
